function getExtension(path) {
  const splitted = path.split('/');
  const entityName = splitted[splitted.length - 1];
  const dotIdx = splitted[splitted.length - 1].lastIndexOf('.');
  const extension = entityName.substr(dotIdx + 1, entityName.length);

  return extension;
}

export default getExtension;
